const LookupValueOrigin = {
  ScannedBarcode: 0,
  SortBoxNumber: 1,
  InvoiceNumber: 2,
  IpackBoxNumber: 3,
};

const LookupValueType = {
  SortBox: 0,
  IpackBoxID: 1,
  Invoice: 2,
};

const ActionStates = {
  LOAD_BOX: 0,
  BOX_LOADED: 1,
  MISSING_SKU: 2,
  COMPLETE_BOX: 4,
  PUTAWAY_STOCK: 5,
};

const WarningTypes = {
  UNDEFINED: -1,
  ChannelQuantityWarning: 1,
  OrderWeightWarning: 2,
};

const AFrameControlStationType = {
  TypeOne: 1,
  TypeTwo: 2,
  TypeThree: 3
};

const SortBoxDivertReason = {
  DEFAULT: 0,
  AFRAME_OTHER: 1,
  FILLING_POINT: 2,
  HEIGHT: 3,
  CHECK_REQUESTED: 4,
  WEIGHT: 5,
  UNKNOWN_LU: 6,
  AFRAME_ORDER_LINE_OTHER: 7,
  PRODUCT_STUCK: 8,
  CHANNEL_LOCKED: 9,
  CHANNEL_EMPTY: 10,
  UNFILLED_QUANTITY: 11,
  READ_ERROR: 12,
  PBL_FULL_ORDER_CARTON: 13,
  DIRTY_CARTON_PBL: 14,
  PBL_HARDWARE_ERROR: 15,
  NO_OPEN_STATION: 16,
  STATION_STILL_OPEN: 17,
  BOX_LOST_OR_REMOVED: 18,
  SHIPPING_LABEL_ERROR: 19,
  GENERAL_PBL_ERROR: 20,
  AFRAME_UNEXPECTED_PRODUCT: 21,
  MAXIMUM_CIRCULATION_REACHED: 22,
  MAGIC_ZONE: 23,
  PRINT_FILE_MISSING_OR_SHIPPING_LABEL_MISSING_OR_UNREADABLE: 23,
  APOTEA_RX_BOX_INSPECTION_REQUIRED: 100,
  APOTEA_RX_BOX_WITH_INCORRECT_STATE_AT_CHECKSTATION: 101,
  NO_ITEM_FOUND_DISCARD_BOX: 1903
};

const AFrameStationID = {
  none: 0,
  CHK01: 1,
  CHK02: 2,
  AFRAME01: 4,
  AFRAME02: 8,
  AFRAME: 16,
  BAL01: 32,
  BAL02: 64,
  BAL03: 128,
  BAL04: 256,
};

export default {
  LookupValueOrigin,
  LookupValueType,
  ActionStates,
  WarningTypes,
  AFrameControlStationType,
  SortBoxDivertReason,
  AFrameStationID,
  
};
